import { Component, OnInit ,Input, EventEmitter,Output} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { CommonService } from "../../services/common.service";
import { PopupComponent } from '../../dialogs/popup/popup.component';
import { HotelhomeService } from '../../hotelhome/services/hotelhome.service';
import { Router,ActivatedRoute } from '@angular/router';
import { RoomSearchService } from '../../room-search/room-search.service';
import * as _moment from 'moment';
import { AuthService } from '../../shared/providers/auth.service';
import {default as _rollupMoment} from 'moment';
const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class CartComponent implements OnInit {
  @Input() showAdditionalLinks: boolean = true; 
  @Input() showAdditionalPOSLinks: boolean = false; 
  @Input() modifyReservation: boolean = false;
  @Output('ClosePopUp') closePopUp: EventEmitter<any> = new EventEmitter();
  // @Input('roomDetailId') roomDetail: string = 'roomDetail';
  @Input('cartClass') cartClass: string = 'roomDetail';
	showLoader: boolean= false;
	showEditFields: any={};
	public hotelData:any = {};
	public OriginalCartData:any = [];
	public cartData:any = [];
	public cartTotal:any = [];
  public reservationInfo:any ={};
	public showCartItem:any =[];
	public totalCartItems;
	private cartSubscription;
	public posProducts;
	public minDate;
  public showCartItems:boolean = false;
  public cartItemHeight:any ={};
  private getLoginStatus; 
  public selectedHotel : number;
  public oldCartId : string;
  /*
  * Constructor to initialize dependency
  */
  constructor(public dialog: MatDialog,
    private authService: AuthService,
    private searchService: RoomSearchService,
    private router: Router,
    private hotelhomeService: HotelhomeService,
    private commonService: CommonService) {
    this.minDate = moment();
    this.selectedHotel = parseInt(localStorage.getItem('hotelID')) ;
    //For Updation of Cart items Count
    this.cartSubscription = this.commonService.totalCartCount.subscribe((cart:any) => {
      if(cart.cartCount === undefined || Object.keys(cart).length === 0){
        this.totalCartItems = 0
      } else {
        if(Object.keys(cart).length>0){
          let cartId = localStorage.getItem('mupog');

          if(this.totalCartItems != parseInt(cart.cartCount) || cartId != this.oldCartId){
            if(cartId != this.oldCartId) {
              this.oldCartId = cartId;
            }
            this.selectedHotel =  parseInt(localStorage.getItem('hotelID')) ;
            this.totalCartItems = parseInt(cart.cartCount);
            this.loadCartData(this.cartClass);
            if(this.totalCartItems > 0){
              this.loadPosData();        
            }
          }
        }
      }
    });
    // this.getLoginStatus = this.authService.checkLoginStatus.subscribe((status:any)=>{
    //   this.selectedHotel =  parseInt(localStorage.getItem('hotelID')) ;
    //   console.log("status",status);
    //   setTimeout(()=>{
    //     if(status === true){
    //       this.loadCartData();
    //       this.loadPosData();        
    //     }
    //   },300);
    // })
  }


  /*********************************
  * For Adding POS product to cart *
  *********************************/
  addToCart(room){
    var mupog =localStorage.getItem('mupog');
    var selectedHotel = JSON.parse(localStorage.getItem('hotelID'));
    this.showLoader = true;
    var selectedPolicy = 2;
    this.reservationInfo.cart_type = 'pos';
    this.reservationInfo.roomTypeName = room.product_name;
    this.reservationInfo.amount= this.reservationInfo.nightlySum= room.product_price;
    this.reservationInfo.service_quantity = 1;
    this.reservationInfo.tax_value = room.tax_value;
    this.reservationInfo.tax_id = room.product_tax;
    this.reservationInfo.tax_name = room.tax_name;
    this.reservationInfo.selectedPolicyId = selectedPolicy;
    if(room.hasOwnProperty('totalDiscount') && room.totalDiscount[selectedPolicy] > 0){
      this.reservationInfo.product_discount = '';
      this.reservationInfo.promo = '';
      this.reservationInfo.promotion_id = '';
    } else {
      this.reservationInfo.product_discount = 0;
    }
    this.reservationInfo.productId = room.product_id;
    if(mupog != undefined && mupog != ''){
      this.reservationInfo.mupog = mupog;
    } 
    this.reservationInfo.selectedHotel = selectedHotel;
    this.searchService.addToCart(this.reservationInfo).then((data:any) => {
        if(data.status == 'error'){
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
          this.showLoader =false;
        } else {
            setTimeout(()=>{
              this.cartData = data.data.cart_data;
              this.cartTotal = data.data.cart_total;
              var totalCartItems = 0;
              this.cartData.forEach((value,index)=>{
                totalCartItems += parseInt(value.service_quantity);
              });
              this.commonService.updateCartData(totalCartItems);
              this.commonService.updateCartItems(this.cartData);
              this.commonService.updateCartItemsTotal(this.cartTotal);
              this.showLoader =false;
            },100);
        }
        this.updateIcons();
    });
    
  }

  /**************************
  * For updating cart icons *
  **************************/
  updateIcons(){
    if(this.cartData.length >0 ){
      this.cartData.forEach((item,index) => {
        this.showEditFields[index] = false;
        this.cartData[index].toMinDate ={};
        let toMinDate = new Date(this.cartData[index].room_stay_from);
        toMinDate.setDate(toMinDate.getDate() + 1);
        this.cartData[index].toMinDate = moment(toMinDate).format('YYYY-MM-DD');
      });
      this.OriginalCartData = JSON.parse(JSON.stringify(this.cartData));
    } else {
      this.showEditFields = {};
      this.OriginalCartData = [];
    }
  }


  showHideProduct(i){
    this.showCartItem[i] = !this.showCartItem[i];
    var Id= this.cartClass+i;
    if(!this.showCartItem[i]){
      document.getElementById(Id).style.height = '0px';
    } else{
      setTimeout(()=>{
        document.getElementById(Id).style.height = this.cartItemHeight[i]+'px';        
      },0);
    }
    
  }

  /********************
  * To Load Cart Data *
  ********************/
  loadCartData(cartClass){
    var mupog = localStorage.getItem('mupog');
    var selectedHotel = this.selectedHotel;
    if(mupog != undefined && mupog !='' ){
      this.commonService.loadCartData({'mupog':mupog,'hotelId':selectedHotel}).then((data:any) => {
          if(data.status === 'success'){
              if(data.data.cart_data != undefined && data.data.cart_data != '' && data.data.cart_data.length>0){
                setTimeout(()=>{
                  this.cartData = data.data.cart_data;
                  this.cartTotal = data.data.cart_total;
                  this.totalCartItems = data.data.cart_data[0].cart_items_count;
                  var width = window.innerWidth;
                  for(let i= 0;i<this.cartData.length;i++){
                    if(width <=640){
                      this.showCartItem[i]=false;
                    } else {
                      this.showCartItem[i]= true;
                    }
                  }
                  this.showCartItems = true;
                  this.updateIcons();
                  this.commonService.updateCartData(this.totalCartItems);
                  this.commonService.updateCartItems(this.cartData);
                  this.commonService.updateCartItemsTotal(this.cartTotal);
                  this.commonService.updateCartHotelData(data.data.selectedHotel);
                  setTimeout(()=>{
                    this.setCartItemHeight(cartClass);
                  },0);
                },0);
               
              }
               else{
                this.cartData = [];
                this.cartTotal = [];
                this.totalCartItems = 0;
                this.commonService.updateCartData(this.totalCartItems);
                this.commonService.updateCartItems(this.cartData);
                this.commonService.updateCartItemsTotal(this.cartTotal);
              }   
          } else {
              this.showLoader = false;
          }
        });
    } 
    // else {
    //     this.cartData = [];
    //     this.cartTotal = [];
    //     this.totalCartItems = 0;
    //     // this.commonService.updateCartData(this.totalCartItems);
    // }
               
  }


  /**************************
  *To Show Error  dialog box*
  **************************/
  openDialog(data): void {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '600px',
      data: data,
       panelClass: 'mlspopblock'
    });

    dialogRef.afterClosed().subscribe(res => {
      
    });
  }

  /********************************
  * For updating number of adults *
  ********************************/
  updateAdults(maxOccupancy,index,type){
    maxOccupancy = parseInt(maxOccupancy);
    var totalGuests = parseInt(this.cartData[index].room_stay_guest_count)+parseInt(this.cartData[index].room_stay_child_count);
    if(type === 'add'){
      if(totalGuests < maxOccupancy){
        this.cartData[index].room_stay_guest_count = parseInt(this.cartData[index].room_stay_guest_count)+1;
      } 
    } else if(type === 'sub'){
        if(parseInt(this.cartData[index].room_stay_guest_count) >= 2){
          this.cartData[index].room_stay_guest_count = parseInt(this.cartData[index].room_stay_guest_count)-1;
        }
    }
  }

  /*****************************
  * For updating number of POS *
  *****************************/

  updatePOSProduct(index,type){
    if(type === 'sub'){
      if(parseInt(this.cartData[index].service_quantity) > 1){
        this.cartData[index].service_quantity = parseInt(this.cartData[index].service_quantity) - 1;
      }
    } else {
        this.cartData[index].service_quantity = parseInt(this.cartData[index].service_quantity) + 1;
    }
  }

  /*******************************
  * For updating number of child *
  *******************************/
  updateChilds(maxOccupancy,index,type){
    maxOccupancy = parseInt(maxOccupancy);
    var totalGuests = parseInt(this.cartData[index].room_stay_guest_count)+parseInt(this.cartData[index].room_stay_child_count);
    if(type === 'add'){
      if(totalGuests < maxOccupancy){
        this.cartData[index].room_stay_child_count = parseInt(this.cartData[index].room_stay_child_count)+1;
      } 
    } else if(type === 'sub'){
        if(parseInt(this.cartData[index].room_stay_child_count) >= 1){
          this.cartData[index].room_stay_child_count = parseInt(this.cartData[index].room_stay_child_count)-1;
        }
    }
  }

  
  /************************************
  * For updating particular cart item *
  ************************************/
  updateCartItem(index){
    this.showLoader = true;
    this.cartData[index].room_stay_from =  moment(this.cartData[index].room_stay_from).format('YYYY-MM-DD');
    this.cartData[index].room_stay_to =  moment(this.cartData[index].room_stay_to).format('YYYY-MM-DD');
    var hotelId =this.selectedHotel;
    hotelId = hotelId;
    var request ={
        'cart_item_id' : this.cartData[index].cart_item_id,
        'mupog' : this.cartData[index].mupog,
        'room_stay_from' : this.cartData[index].room_stay_from,
        'room_stay_to' : this.cartData[index].room_stay_to,
        'adult' : this.cartData[index].room_stay_guest_count,
        'child' : this.cartData[index].room_stay_child_count,
        'policy_id' : this.cartData[index].policy_id,
        'product_id' : this.cartData[index].product_id,
        'room_type_id' : this.cartData[index].cart_room_type_id,
        'hotelId' : hotelId
    }
    this.commonService.updateCart(request).then((data:any) => {
      if(data.status === 'success'){
        setTimeout(()=>{
          this.cartData = data.data.cart_data;
          this.cartTotal = data.data.cart_total;
          var totalCartItems = data.data.cart_data[0].cart_items_count;
          this.commonService.updateCartData(totalCartItems);
          this.commonService.updateCartItems(this.cartData);
          this.commonService.updateCartItemsTotal(this.cartTotal);
          this.showLoader = false;  
        },100);
      } else {
          this.showLoader = false;
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
      }
      this.updateIcons();
    });
  }


  /***********************************
  * For Deleting Particular cart item*
  ***********************************/
  deleteCartItem(cartItemId,mupog){
    this.showLoader =true;
    var selectedHotel = this.selectedHotel;
    this.commonService.deleteCartItem({'cart_item_id':cartItemId,'mupog':mupog,'hotelId':selectedHotel}).then((data:any) => {
      if(data.status === 'success'){
          if(data.data.cart_data != undefined && data.data.cart_data != '' ){
              if(data.data.cart_data.length>0){
                setTimeout(()=>{
                  this.cartData = data.data.cart_data;
                  this.cartTotal = data.data.cart_total;
                  this.totalCartItems = data.data.cart_data[0].cart_items_count;
                  this.commonService.updateCartData(this.totalCartItems);
                  this.commonService.updateCartItems(this.cartData);
                  this.commonService.updateCartItemsTotal(this.cartTotal);              
                },100);
              } else{
                setTimeout(()=>{
                  this.cartData = [];
                  this.cartTotal = [];
                  this.totalCartItems = 0;
                  localStorage.removeItem('mupog');
                  this.commonService.updateCartData(this.totalCartItems);
                  this.commonService.updateCartItems(this.cartData);
                  this.commonService.updateCartItemsTotal(this.cartTotal);
                  if(this.router.url == '/checkout'){
                      this.router.navigate(['']);
                  }
                },100);
              }

          } else{
            setTimeout(()=>{
              this.cartData = [];
              this.cartTotal = [];
              this.totalCartItems = 0;
              localStorage.removeItem('mupog');
              this.commonService.updateCartData(this.totalCartItems);
              this.commonService.updateCartItems(this.cartData);
              this.commonService.updateCartItemsTotal(this.cartTotal);
              if(this.router.url == '/checkout'){
                this.router.navigate(['']);
              }
            },100);
          }
          this.commonService.updateCartStatus({'status':'single'+this.totalCartItems});
          this.showLoader = false;
          
      } else {
          this.showLoader = false;
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
      }
      this.updateIcons();
          
    });
  }

  /******************************
  * For Toggling of Edit Fields *
  *******************************/
  toggleEdit(index:any, id:any){
    let Id = id+index;
    document.getElementById(Id).style.height = 'auto';
    this.showEditFields[index] = !this.showEditFields[index];
  }
  
  /********************************
  * To cancel update of cart item *
  ********************************/

  cancelEdit(index:any, id:any){
    this.cartData[index] = JSON.parse(JSON.stringify(this.OriginalCartData[index]));
    this.toggleEdit(index, id);
  }



  /*******************************
  * To Delete All Items From Cart*
  ********************************/
  cancelCart(){
    this.showLoader = true;
    var mupog = localStorage.getItem('mupog');
    var hotelId =this.selectedHotel;
    var cartData = {'hotelId':hotelId,'mupog':mupog,'cartItemIds':[]};
    this.showLoader = true;
    this.cartData.forEach((item,index) => {
      cartData.cartItemIds[index] = item.cart_item_id;
    });
    this.commonService.deleteCart(cartData).then((data:any) => {
      if(data.status === 'success'){
        if(data.data.length === 0){
          setTimeout(()=>{
            this.cartData = [];
            this.cartTotal = [];
            this.totalCartItems = 0;
            localStorage.removeItem('cartData');
            localStorage.removeItem('mupog');
            localStorage.removeItem('cartTotal');
            localStorage.removeItem('cartHotelData');
            localStorage.removeItem('billingData');
            localStorage.removeItem('travellers');
            localStorage.removeItem('continueAsGuest');
            this.commonService.updateCartData(this.totalCartItems);
            this.commonService.updateCartItems(this.cartData);
            this.commonService.updateCartItemsTotal(this.cartTotal);
            this.commonService.updateCartStatus({'status':'multiple--'+JSON.stringify(cartData)});
            if(this.router.url == '/checkout'){
                this.router.navigate(['']);
            }
          },100);
        }
        this.showLoader = false;  
      } else {
          this.showLoader = false;
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
      }
      this.updateIcons();
      this.showLoader = false;
    });
  }

  /*******************************
  * To load POS Products in cart *
  ********************************/
  loadPosData(){
    this.commonService.getPOSProductsFe({'hotelId':this.selectedHotel}).then((data:any) => {
        this.posProducts = data;
    });
  }

  /****************************
  * Navigate to checkout page *
  ****************************/

  checkout(hotel_code){
    // this.showLoader = true;
    setTimeout(() => {
      this.router.navigate(['checkout']);
      this.closePopUp.emit();
    },100);
  }
  /**********************************
  * Update roomstayFrom and To dates*
  **********************************/
  changeRoomStayFromDate(index) {
    let from = moment(this.cartData[index].room_stay_from).format('YYYY-MM-DD');
    let toDate = moment(this.cartData[index].room_stay_to).format('YYYY-MM-DD');
    if(moment(toDate).isSameOrBefore(from)){
      this.cartData[index].room_stay_to = moment(from).add(2, 'day');
      this.cartData[index].toMinDate = moment(from).add(1, 'day');
    }
  }

  setCartItemHeight(cartClass){
    var width = window.innerWidth;
    if(width <= 640){
      for(let i= 0;i<this.cartData.length;i++){
          var Id= cartClass+i;
          if(document.getElementById(Id)) {
            this.cartItemHeight[i] = document.getElementById(Id).offsetHeight;
            document.getElementById(Id).style.height = '0px';
          }
          
      }
    }
  }

  ngAfterViewInit() {
    
  }
  ngOnInit() {
    this.oldCartId = localStorage.getItem('mupog');
    this.loadCartData(this.cartClass);
    this.loadPosData();
  }

  // unsubscribe on destroy
  ngOnDestroy() {
    this.cartSubscription.unsubscribe();
    this.cartClass = '';
  }

  /************************************
  * For updating particular cart item *
  ************************************/
 updatePosItem(index){
    this.showLoader = true;
    var hotelId =this.selectedHotel;
    hotelId = hotelId;
    var request ={
        'cart_item_id' : this.cartData[index].cart_item_id,
        'service_quantity':this.cartData[index].service_quantity,
        'mupog' : this.cartData[index].mupog,
        'policy_id' : this.cartData[index].policy_id,
        'product_id' : this.cartData[index].product_id,
        'room_type_id' : this.cartData[index].cart_room_type_id,
        'hotelId' : hotelId,
        'request_type': 'update_pos_quantity'
    }

    this.commonService.updatePosCart(request).then((data:any) => {
      if(data.status === 'success'){
        setTimeout(()=>{
          this.cartData = data.data.cart_data;
          this.cartTotal = data.data.cart_total;
          var totalCartItems = data.data.cart_data[0].cart_items_count;
          this.commonService.updateCartData(totalCartItems);
          this.commonService.updateCartItems(this.cartData);
          this.commonService.updateCartItemsTotal(this.cartTotal);
          this.OriginalCartData = JSON.parse(JSON.stringify(this.cartData));
          this.showLoader = false;  
        },100);
      } else {
          this.showLoader = false;
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
      }
      this.updateIcons();
    });
  }
}
